module.exports = __webpack_public_path__ + "static/img/10013 (3).8556dba.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10013 (3).webp
// module id = CIex
// module chunks = 14